<template>
  <AutocompleteField
    :value="model"
    :items="items"
    :loading="loading"
    :placeholder="context.attributes.placeholder || 'Type a drug name…'"
    @input="model = $event"
    @search="search"
    @items-clear="items = []"
    @select="onSelect"
  />
</template>

<script>
// Custom vue-formulate type "drug": medication drug-name autocomplete backed by
// the self-hosted `drugs` table (PostgREST), replacing the old Algolia index.
// On select it stores the trade name and, when present in the same medication
// group, fills the sibling `activeSubstance` field too (as the original did).
import { rest } from 'helpers/api'

export default {
  name: 'FormulateDrugAutocomplete',
  props: { context: { type: Object, required: true } },
  data() {
    return { items: [], loading: false }
  },
  computed: {
    model: {
      get() {
        return this.context.model || ''
      },
      set(v) {
        this.context.model = v
      },
    },
  },
  methods: {
    async search(q) {
      this.loading = true
      try {
        const rows = await rest.searchDrugs(q)
        this.items = rows.map(r => ({
          label: r.active_substance
            ? `${r.name} — ${r.active_substance}`
            : r.name,
          value: r.name,
          raw: r,
        }))
      } catch (e) {
        this.items = []
      } finally {
        this.loading = false
      }
    },
    onSelect(item) {
      this.model = item.value
      this.items = []
      const substance = item.raw && item.raw.active_substance
      if (substance) this.fillActiveSubstance(substance)
      this.$emit('drug-selected', item.raw)
    },
    // Fill the sibling "Active Substance" field in the SAME medication row.
    // Setting the DOM value alone doesn't stick (vue-formulate re-renders from its
    // own model), so we locate the sibling FormulateInput's component instance via
    // its root element and set its `context.model` — the vue-formulate-native way,
    // which updates the form data. Scoped to this repeatable row so multiple
    // medication rows don't cross-fill.
    fillActiveSubstance(substance) {
      // Defer past the re-render that setting the drug name triggers, then locate
      // the sibling field fresh and set its model. setTimeout (not $nextTick) so it
      // runs after vue-formulate has finished reconciling the group item.
      setTimeout(() => {
        const row =
          this.$el.closest('.formulate-input-group-repeatable') ||
          this.$el.closest('.formulate-input-grouping') ||
          this.$el.parentElement
        if (!row) return
        let fiEl = null
        row.querySelectorAll('.formulate-input').forEach(el => {
          const lbl = el.querySelector('.formulate-input-label')
          if (lbl && /active substance/i.test(lbl.textContent)) fiEl = el
        })
        if (fiEl && fiEl.__vue__ && fiEl.__vue__.context) {
          fiEl.__vue__.context.model = substance
        }
      }, 60)
    },
  },
}
</script>
